<template>
  <div style="display:flex;flex-direction:column;">
    <!-- <Header :class="{header:isIndexGetter}" /> -->
    <Header />
    <router-view id="v-content" class="router-view" :style="{minHeight: Height+'px'}" />
    <!-- <NewFooter /> -->
  </div>
</template>

<script>
import Header from '../base/header/Header'
// import NewFooter from '../base/footer/NewFooter'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    Header
    // NewFooter
  },
  data() {
    return {
      Height: 0
    }
  },
  computed: {
    ...mapGetters(['isIndexGetter', 'websiteMesGetter'])
  },
  watch: {
    '$route'(to, from) {
      window.scrollTo(0, 0)
    }
  },
  mounted() {
    // 动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.Height = document.documentElement.clientHeight - 350
    // 监听浏览器窗口变化
    window.onresize = () => { this.Height = document.documentElement.clientHeight - 350 }
  },
  methods: {
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: transparent;
}
.footer {
  z-index: 999;

  /* top: 50px; */
  /* /* bottom: 0;  */
}
</style>
